import { MemberDto } from '@careapp-group/ng-sdk';
import { Action, createAction, props } from '@ngrx/store';

const REQUEST_LOGGED_IN_USER = '[Auth][Request] get logged in user';
const RESPONSE_SUCCESS_LOGGED_IN_USER = '[Auth][Response][Success] get logged in user';
const RESPONSE_FAIL_LOGGED_IN_USER = '[Auth][Response][Fail] get logged in user';

const REQUEST_USER_ROLES = '[Auth][Request] User Roles';
const RESPONSE_SUCCESS_USER_ROLES = '[Auth][Response][Success] User Roles';
const RESPONSE_FAIL_USER_ROLES = '[Auth][Response][Fail] User Roles';

const AUTH_RESET_ERRORS = '[Auth] Auth Reset Errors';

const HYDRATE_AUTH = '[Auth] Hydrate Auth';

export const RequestLoggedInUser = createAction(
  REQUEST_LOGGED_IN_USER,
  props<{ payload: string }>()
);

export const ResponseSuccessLoggedInUser = createAction(
  RESPONSE_SUCCESS_LOGGED_IN_USER,
  props<{ payload: MemberDto }>()
);

export const ResponseFailLoggedInUser = createAction(
  RESPONSE_FAIL_LOGGED_IN_USER,
  props<{ payload: any }>()
);

export const RequestUserRoles = createAction(REQUEST_USER_ROLES);

export const ResponseSuccessUserRoles = createAction(
  RESPONSE_SUCCESS_USER_ROLES,
  props<{ payload: string[] }>()
);

export const ResponseFailUserRoles = createAction(
  RESPONSE_FAIL_USER_ROLES,
  props<{ payload: any }>()
);

export const AuthResetErrorsAction = createAction(AUTH_RESET_ERRORS);

export const HydrateAuth = createAction(
  HYDRATE_AUTH,
  props<{ payload?: { id: string; userId: string } }>()
);

export * from './login/login.actions';
export * from './logout/logout.actions';
export * from './recovery/recovery.actions';
export * from './registration/registration.actions';
export * from './settings/settings.actions';
export * from './verification/verification.actions';
